module.exports = __webpack_public_path__ + "img/port6.f3fe3c65.png";